{
  "edit": {
    "title": "Endre entreprenør",
    "company": {
      "title": "Entreprenøropplysninger",
      "description": "Legg til eller endre opplysninger rundt entreprenører"
    },
    "contact": {
      "title": "Kontaktinformasjon",
      "description": "Registrer kontaktinformasjon til entreprenør"
    },
    "office": {
      "title": "Ansvarlig kontor i Viken Skog (eller SB Skog)",
      "description": "Velg hvilket kontor som skal være ansvarlig for entreprenøren"
    },
    "fields": {
      "organizationNumber": "Organisasjonsnummer",
      "contractorName": "Entreprenørnavn",
      "bankAccountNumber": "Kontonummer",
      "bankAccountNumberDescription": "Eksempel: 1111 22 33334",
      "streetName": "Forretningsadresse",
      "streetNameDescription": "Eksempel: Tømmergata",
      "houseNumber": "Husnummer",
      "houseNumberDescription": "Eksempel: 16C",
      "postalCode": "Postnummer",
      "postalCodeDescription": "Eksempel: 0123",
      "city": "Sted",
      "cityDescription": "Eksempel: Oslo",
      "email": "E-post",
      "emailDescription": "Eksempel: kontakt@nordmann.no",
      "phone": "Telefonnummer",
      "phoneDescription": "Eksempel: 91 23 45 67",
      "office": "Kontor",
      "officePlaceholder": "Velg kontor"
    },
    "cancel": "Avbryt",
    "save": "Lagre endringer",
    "saveSuccess": "Endringene er lagret",
    "saveError": "Kunne ikke lagre endringene. Prøv igjen.",
    "inactiveError": "Kan ikke redigere en deaktivert entreprenør. Gjenopprett entreprenøren først.",
    "cancelDialog": {
      "title": "Vil du avbryte endring av entreprenør?",
      "description": "Alle endringer du har gjort vil gå tapt og må fylles inn på nytt.",
      "confirmCancel": "Avbryt uten å lagre",
      "continueEditing": "Fortsett å endre"
    }
  },
  "profile": {
    "breadcrumb": "Entreprenør",
    "tabs": {
      "ariaLabel": "Entreprenørnavigasjon",
      "overview": "Oversikt",
      "resources": "Ressurser",
      "documents": "Dokumenter",
      "history": "Historikk"
    },
    "history": {
      "breadcrumb": "Historikk",
      "chooseTimeframe": "Velg periode",
      "tabs": {
        "ariaLabel": "Historikknavigasjon",
        "events": "Hendelser",
        "sms": "SMS"
      },
      "sms": {
        "title": "SMS-historikk",
        "description": "Oversikt over alle SMS sendt til entreprenør",
        "allSenders": "Alle avsendere",
        "loading": "Laster SMS-historikk...",
        "loadingError": "Kunne ikke laste SMS-historikk: {{message}}",
        "paginationLabel": "SMS per side",
        "empty": {
          "title": "Ingen SMS utsendelser",
          "titleFiltered": "Ingen SMS utsendelser funnet",
          "description": {
            "none": "Det er ikke sendt noen SMS til entreprenør ennå",
            "senderOnly": "Det er ikke sendt SMS fra {{sender}}",
            "fromDateOnly": "Det er ikke sendt SMS etter {{from}}",
            "fromDateOnlyWithSender": "Det er ikke sendt SMS fra {{sender}} etter {{from}}",
            "filtered": "Fant ingen SMS fra i valgt periode {{from}} - {{to}}.\nPrøv å justere filterne."
          }
        }
      }
    },
    "resources": {
      "breadcrumb": "Ressurser",
      "tabs": {
        "ariaLabel": "Ressursnavigasjon",
        "machines": "Maskiner",
        "forestCrews": "Skoglag"
      }
    },
    "partnerData": {
      "edit": "Endre entreprenøropplysninger",
      "title": "Entreprenøroversikt",
      "bankAccount": "Bankkonto",
      "address": "Adresse",
      "country": "Land",
      "contactInformation": {
        "title": "Kontaktinformasjon",
        "phone": "Telefon",
        "email": "E-post"
      },
      "responsibleOffice": {
        "title": "Ansvarlig kontor",
        "office": "Kontor"
      }
    },
    "statusToggle": {
      "menuAriaLabel": "Flere handlinger",
      "menuDeactivate": "Deaktiver entreprenør",
      "menuActivate": "Gjenopprett entreprenør",
      "inactiveAlert": {
        "title": "Entreprenøren er deaktivert",
        "description": "Deaktiverte profiler kan ikke velges for oppdrag før de blir gjenopprettet",
        "action": "Gjenopprett entreprenør"
      },
      "errorTitle": "Kunne ikke oppdatere status",
      "error": "Det oppstod en feil under oppdatering av status. Prøv igjen."
    },
    "error": {
      "title": "Kunne ikke laste entreprenør",
      "description": "Det oppstod en feil under lasting av entreprenøropplysninger. Prøv igjen.",
      "retry": "Prøv igjen",
      "goToOverview": "Gå til oversikt"
    },
    "quickActions": {
      "sendSms": {
        "title": "Send SMS",
        "description": "Send SMS til entreprenøren"
      },
      "accessManagement": {
        "title": "Tilgangsstyring",
        "description": "Administrer tilgang til mine sider"
      },
      "accounting": {
        "title": "Regnskap",
        "description": "Åpne kundesiden i Visma Accounting"
      }
    },
    "employees": {
      "title": "Ansatte",
      "description": "Liste over ansatte knyttet til denne entreprenøren",
      "addEmployee": "Legg til ansatt",
      "emptyState": {
        "title": "Ingen ansatte registrert på denne entreprenøren",
        "description": "Trykk på \"Registrer ny ansatt\" for å starte prosessen"
      },
      "table": {
        "columns": {
          "name": "Navn",
          "email": "E-post",
          "phoneNumber": "Telefonnummer",
          "machineOperatorType": "Maskinfører type",
          "courses": "Kurs"
        },
        "machineOperatorType": {
          "harvestingMachine": "Hogstmaskin",
          "forwarder": "Lassbærer",
          "both": "Hogstmaskin & Lassbærer"
        },
        "courses": {
          "completedAll": "Alle fullført",
          "completedPartial": "{{completed}} av {{total}} fullført",
          "drawer": {
            "title": "Kursoversikt",
            "titleWithEmployee": "Kurs - {{employeeName}}",
            "subtitle": "Oversikt over kurs for den ansatte",
            "completedCoursesTitle": "Fullførte kurs",
            "missingCoursesTitle": "Manglende kurs",
            "close": "Lukk",
            "editCourses": "Endre kurs"
          }
        },
        "actions": {
          "viewRemark": "Vis merknad",
          "openCourses": "Åpne kursoversikt",
          "edit": "Endre",
          "delete": "Slett"
        },
        "none": "Ingen",
        "loadingMessage": "Laster ansatte...",
        "emptyTitle": "Ingen ansatte registrert på denne entreprenøren",
        "emptyDescription": "Trykk på \"Legg til ansatt\" for å starte registrering",
        "errorTitle": "Kunne ikke laste ansatte",
        "errorDescription": "Det oppstod en feil under lasting av ansatte. Prøv igjen.",
        "remarkDialog": {
          "title": "Merknad",
          "close": "Lukk",
          "edit": "Endre merknad"
        },
        "deleteDialog": {
          "validating": {
            "title": "Er du sikker på at du vil slette {{name}}?",
            "cancel": "Avbryt"
          },
          "confirm": {
            "title": "Er du sikker på at du vil slette {{name}}?",
            "description": "Denne ansatte vil bli permanent slettet. All data fjernes og handlingen kan ikke angres.",
            "cancel": "Avbryt",
            "action": "Slett ansatt"
          },
          "impact": {
            "title": "Er du sikker på at du vil slette {{name}}?",
            "description": "Denne ansatte er registrert som eneste sjåfør for {{machineIds}}.\n Hvis du sletter personen, mister maskinen sjåføren sin og kan ikke brukes i oppdrag før en ny sjåfør er satt.",
            "action": "Slett ansatt",
            "cancel": "Avbryt"
          },
          "blocked": {
            "title": "Kan ikke slette {{name}}",
            "description": "Denne ansatte er eneste sjåfør for {{machineIds}}, som er i et aktivt oppdrag.\n For å slette personen må maskinen tas ut av oppdrag eller tildeles en annen sjåfør først.",
            "cancel": "OK"
          },
          "errorTitle": "Kunne ikke slette ansatt",
          "errorDescription": "Det oppstod en feil under sletting av ansatt. Prøv igjen."
        }
      }
    },
    "sendSMS": {
      "sendSMS": "Send SMS",
      "backNavText": "Tilbake til entreprenøren",
      "receiverLabel": "Mottaker",
      "receiversDescription": "Velg en eller flere mottakere",
      "allRecipientsSelected": "Alle mottakere er valgt",
      "contractor": "Entreprenør",
      "employee": "Ansatt",
      "forestCrew": "Skoglag",
      "messageLabel": "Melding",
      "messageDescription": "Skriv meldingen du ønsker å sende",
      "messagePlaceholder": "Skriv her...",
      "characters": "tegn",
      "sms": "SMS",
      "missingPhoneTitle": "Telefonnummer mangler",
      "missingPhoneDescription": "For å kunne sende SMS må telefonnummer på entreprenør eller ansatt være registrert. Legg inn telefonnummer for entreprenør under «Endre entreprenøropplysninger» eller for ansatt under «registrer ny ansatt» på oversiktssiden.",
      "longMessageWarningTitle": "SMS kostnaden øker ved lange meldinger!",
      "longMessageWarningDescription": "Meldingen overskrider 160 tegn, som er grensen for én SMS. Kostnaden øker jo flere SMS-er den deles opp i. Mottakeren ser den likevel som én sammenhengende melding",
      "messageRequired": "Meldingen kan ikke være tom. Skriv inn teksten du vil sende",
      "messageTooLong": "Meldingen er for lang",
      "recipientsRequired": "Mottakere må velges",
      "successTitle": "Meldingen er sendt",
      "successDescription": "Sendingen av meldingen var vellykket",
      "noPhone": "Mangler telefonnummer"
    }
  },
  "editMachine": {
    "title": "Rediger maskin",
    "backLink": "Tilbake til ressurser",
    "form": {
      "title": "Rediger informasjon om maskinen",
      "description": "Oppdater feltene under for å endre maskinen"
    },
    "fields": {
      "machineBrand": {
        "label": "Maskinmerke",
        "placeholder": "Velg merke"
      },
      "machineType": {
        "label": "Maskintype",
        "placeholder": "Velg type"
      },
      "modelName": {
        "label": "Modellnavn",
        "description": "Eksempel: 1270G"
      },
      "manufacturingYear": {
        "label": "Årsmodell"
      },
      "machineId": {
        "label": "Maskin ID",
        "description": "Fyll inn de 5 siste sifrene i chassisnummeret (Eksempel: 54321)"
      },
      "drivers": {
        "label": "Sjåfør",
        "description": "Legg til hvem som er sjåføren til maskinen",
        "placeholder": "Velg sjåfør"
      },
      "addWithoutDriver": {
        "label": "Legg til uten sjåfør",
        "description": "Velg dette hvis du vil registrere maskinen uten sjåfør. Maskinen markeres som uten sjåfør i oversikten og kan ikke brukes i oppdrag før sjåfør er satt."
      },
      "buckingSystem": {
        "label": "Navn på apteringssystem (valgfritt)"
      },
      "remark": {
        "label": "Merknad (valgfritt)"
      }
    },
    "additionalInfo": {
      "title": "Tilleggsinformasjon",
      "description": "Fyll inn tilleggsinformasjon om maskinen"
    },
    "generatedName": {
      "title": "Generert maskinnavn",
      "description": "Maskinnavn genereres når all nødvendig informasjon er fylt inn"
    },
    "actions": {
      "cancel": "Avbryt",
      "save": "Lagre endringer"
    },
    "toast": {
      "success": {
        "title": "Maskinen er oppdatert",
        "description": "\"{{machineName}}\" er oppdatert."
      },
      "error": {
        "title": "Kunne ikke oppdatere maskinen",
        "description": "Det oppstod en feil ved lagring. Prøv igjen."
      }
    },
    "error": {
      "title": "Kunne ikke laste maskinen",
      "description": "Det oppstod en feil under lasting av maskinopplysninger. Prøv igjen.",
      "retry": "Prøv igjen",
      "goToResources": "Gå til ressurser"
    }
  },
  "addMachine": {
    "title": "Legg til maskin",
    "backLink": "Tilbake til ressurser",
    "form": {
      "title": "Registrer informasjon om maskinen",
      "description": "Fyll inn feltene under for å legge til en maskin"
    },
    "fields": {
      "machineBrand": {
        "label": "Maskinmerke",
        "placeholder": "Velg merke"
      },
      "machineType": {
        "label": "Maskintype",
        "placeholder": "Velg type"
      },
      "modelName": {
        "label": "Modellnavn",
        "description": "Eksempel: 1270G"
      },
      "manufacturingYear": {
        "label": "Årsmodell"
      },
      "machineId": {
        "label": "Maskin ID",
        "description": "Fyll inn de 5 siste sifrene i chassisnummeret (Eksempel: 54321)"
      },
      "drivers": {
        "label": "Sjåfør",
        "description": "Legg til hvem som er sjåføren til maskinen",
        "placeholder": "Velg sjåfør"
      },
      "addWithoutDriver": {
        "label": "Legg til uten sjåfør",
        "description": "Velg dette hvis du vil registrere maskinen uten sjåfør. Maskinen markeres som uten sjåfør i oversikten og kan ikke brukes i oppdrag før sjåfør er satt."
      },
      "acknowledgeDriverCompetenceWarning": {
        "label": "Jeg vil fortsette likevel",
        "description": "Maskinen lagres selv om valgte sjåfører ikke har nødvendig kompetanse for denne maskintypen. Endre sjåfører i oversikten ved behov."
      },
      "buckingSystem": {
        "label": "Navn på apteringssystem (valgfritt)"
      },
      "remark": {
        "label": "Merknad (valgfritt)"
      }
    },
    "machineType": {
      "options": {
        "gravemaskin": "Gravemaskin",
        "hogstmaskin": "Hogstmaskin",
        "lassbaerer": "Lassbærer",
        "markbereder": "Markbereder"
      }
    },
    "driverCompetenceWarning": {
      "title": "Sjåfør mangler nødvendig kompetanse",
      "descriptionOne": "{{name}} har ikke registrert kompetanse på valgt maskintype. Bekreft under for å lagre maskinen likevel.",
      "descriptionMany": "Følgende sjåfører har ikke registrert kompetanse på valgt maskintype: {{names}}. Bekreft under for å lagre maskinen likevel."
    },
    "additionalInfo": {
      "title": "Tilleggsinformasjon",
      "description": "Fyll inn tilleggsinformasjon om maskinen"
    },
    "generatedName": {
      "title": "Generert maskinnavn",
      "description": "Maskinnavn genereres når all nødvendig informasjon er fylt inn"
    },
    "actions": {
      "cancel": "Avbryt",
      "save": "Lagre maskin"
    },
    "toast": {
      "success": {
        "title": "Maskinen er opprettet",
        "description": "\"{{machineName}}\" er lagt til på entreprenøren."
      },
      "error": {
        "title": "Kunne ikke opprette maskinen",
        "description": "Det oppstod en feil ved lagring. Prøv igjen."
      }
    }
  },
  "addForestCrew": {
    "title": "Legg til skoglag",
    "backLink": "Tilbake til ressurser",
    "form": {
      "title": "Registrer informasjon om skoglaget",
      "description": "Fyll inn feltene under for å legge til et skoglag"
    },
    "fields": {
      "leaderName": {
        "label": "Navn på leder",
        "description": "Eksempel: Kari Nordmann"
      },
      "phoneNumber": {
        "label": "Telefonnummer",
        "description": "Eksempel: 91 23 45 67"
      },
      "municipalities": {
        "label": "Kommuner",
        "description": "Velg hvilke kommuner skoglaget har ansvar for"
      },
      "remark": {
        "label": "Merknad (valgfritt)"
      }
    },
    "actions": {
      "cancel": "Avbryt",
      "save": "Lagre skoglag"
    },
    "cancelDialog": {
      "title": "Vil du avbryte registrering av skoglag?",
      "description": "All informasjon du har fylt ut vil gå tapt og må fylles inn på nytt",
      "confirmCancel": "Avbryt uten å lagre",
      "continueEditing": "Fortsett registrering"
    },
    "toast": {
      "success": {
        "title": "Skoglag opprettet",
        "description": "Skoglaget ble lagt til."
      },
      "error": {
        "title": "Kunne ikke opprette skoglaget",
        "description": "Det oppstod en feil ved lagring. Prøv igjen."
      }
    }
  },
  "addEmployee": {
    "title": "Legg til ansatt",
    "backLink": "Tilbake til entreprenøren",
    "sections": {
      "contactInformation": {
        "title": "Kontaktopplysninger",
        "description": "Fyll inn informasjon om den ansatte"
      },
      "machineOperatorType": {
        "title": "Maskinfører type",
        "description": "Velg hvilke maskiner denne ansatte kan operere. Dette gjør at personen kan settes som sjåfør når maskiner registreres"
      },
      "courses": {
        "title": "Kurs",
        "description": "Registrer hvilke kurs denne ansatte har fullført. Alle kursene er obligatoriske, og mangler vil vises i oversikten over ansatte"
      },
      "notes": {
        "title": "Merknad"
      }
    },
    "fields": {
      "firstName": {
        "label": "Fornavn",
        "description": "Eksempel: Ola"
      },
      "lastName": {
        "label": "Etternavn",
        "description": "Eksempel: Nordmann"
      },
      "email": {
        "label": "E-post",
        "description": "Eksempel: ola@nordmann.no"
      },
      "phoneNumber": {
        "label": "Telefonnummer",
        "description": "Eksempel: 91 23 45 67"
      },
      "harvester": {
        "label": "Hogstmaskin",
        "description": "Kan kjøre hogstmaskin."
      },
      "forwarder": {
        "label": "Lassbærer",
        "description": "Kan kjøre lassbærer."
      },
      "notes": {
        "placeholder": "Skriv her..."
      }
    },
    "actions": {
      "cancel": "Avbryt",
      "save": "Lagre ansatt",
      "manageRequiredCourses": "Administrer obligatoriske kurs"
    },
    "manageCourses": {
      "title": "Administrer obligatoriske kurs",
      "description": "Legg til, endre eller fjern kurs fra listen over obligatoriske kurs for alle ansatte hos entreprenøren",
      "addCourse": "Legg til nytt kurs",
      "editCourse": "Rediger kurs: {{name}}",
      "saveChanges": "Lagre endringer",
      "close": "Lukk",
      "courseDefinition": {
        "addTitle": "Legg til nytt kurs",
        "editTitle": "Endre kurs",
        "nameLabel": "Kursnavn",
        "nameDescription": "Skriv inn et kort navn for kurset, maks 15 karakterer",
        "descriptionLabel": "Beskrivelse",
        "descriptionDescription": "Oppgi en kort beskrivelse av kurset",
        "saveAdd": "Lagre",
        "saveEdit": "Lagre endringer",
        "remove": "Slett kurs",
        "cancel": "Avbryt",
        "deleteConfirm": {
          "title": "Vil du slette kurset {{name}}?",
          "description": "All informasjon du har fylt ut vil gå tapt.",
          "action": "Slett kurs",
          "cancel": "Avbryt"
        },
        "toast": {
          "add": {
            "success": {
              "title": "Kurs lagt til",
              "description": "Kurset ble lagt til."
            },
            "error": {
              "title": "Kunne ikke legge til kurs",
              "description": "Det oppstod en feil ved lagring. Prøv igjen."
            }
          },
          "edit": {
            "success": {
              "title": "Kurs oppdatert",
              "description": "Kurset ble oppdatert."
            },
            "error": {
              "title": "Kunne ikke oppdatere kurs",
              "description": "Det oppstod en feil ved lagring. Prøv igjen."
            }
          },
          "delete": {
            "success": {
              "title": "Kurs slettet",
              "description": "Kurset ble slettet."
            },
            "error": {
              "title": "Kunne ikke slette kurs",
              "description": "Det oppstod en feil ved sletting. Prøv igjen."
            }
          }
        }
      }
    },
    "cancelDialog": {
      "title": "Vil du avbryte registrering av ansatt?",
      "description": "All informasjon du har fylt ut vil gå tapt og må fylles inn på nytt.",
      "confirmCancel": "Avbryt registrering",
      "continueEditing": "Fortsett registrering"
    },
    "toast": {
      "success": {
        "title": "Ansatt opprettet",
        "description": "Den ansatte ble lagt til."
      },
      "error": {
        "title": "Kunne ikke opprette ansatt",
        "description": "Det oppstod en feil ved lagring. Prøv igjen."
      }
    },
    "courses": {
      "loading": "Laster kurs...",
      "empty": "Ingen kurs registrert for denne entreprenøren"
    },
    "error": {
      "title": "Kunne ikke laste siden",
      "description": "Det oppstod en feil ved henting av data.",
      "retry": "Prøv igjen"
    }
  },
  "editEmployee": {
    "title": "Endre ansattopplysninger",
    "backLink": "Tilbake til oversikt",
    "fields": {
      "machineOperatorType": {
        "label": "Maskinfører type",
        "none": "Ingen",
        "harvester": "Hogstmaskin",
        "forwarder": "Lassbærer",
        "both": "Hogstmaskin & Lassbærer"
      }
    },
    "actions": {
      "cancel": "Avbryt",
      "save": "Lagre ansatt"
    },
    "cancelDialog": {
      "title": "Vil du avbryte redigering av ansatt?",
      "description": "Endringene du har gjort blir ikke lagret.",
      "confirmCancel": "Avbryt redigering",
      "continueEditing": "Fortsett redigering"
    },
    "toast": {
      "success": {
        "title": "Ansatt oppdatert",
        "description": "Endringene ble lagret."
      },
      "error": {
        "title": "Kunne ikke oppdatere ansatt",
        "description": "Det oppstod en feil ved lagring. Prøv igjen."
      }
    },
    "error": {
      "title": "Kunne ikke hente ansatt",
      "description": "Det oppstod en feil ved henting av ansattdata.",
      "retry": "Prøv igjen"
    },
    "courses": {
      "loading": "Laster kurs...",
      "empty": "Ingen kurs registrert for denne entreprenøren"
    }
  },
  "register": {
    "title": "Registrer ny entreprenør",
    "breadcrumb": "Registrer entreprenør",
    "stepper": {
      "step1": "Bedriftsinformasjon",
      "step2": "Oppsummering"
    },
    "step1": {
      "title": "Entreprenørinformasjon",
      "description": "Fyll inn informasjon om entreprenøren",
      "organizationNumber": {
        "label": "Organisasjonsnummer",
        "description": "Skriv inn organisasjonsnummeret (9 siffer)",
        "placeholder": "9 siffer",
        "duplicateError": "Organisasjonsnummeret er allerede i bruk, prøv et annet",
        "duplicateAlertTitle": "Organisasjonsnummeret er allerede knyttet til en eksisterende entreprenørprofil",
        "duplicateAlertDescription": "Er profilen inaktiv, kan du aktivere den for videre bruk.",
        "duplicateAlertTitleWithName": "Organisasjonsnummeret er allerede knyttet til entreprenørprofilen {{name}}",
        "duplicateAlertButton": "Gå til entreprenørprofil"
      },
      "companyName": {
        "label": "Entreprenørnavn"
      },
      "bankAccount": {
        "label": "Kontonummer",
        "labelSummary": "Kontonummer",
        "description": "Eksempel: 1111 22 33334"
      },
      "address": {
        "title": "Adresse",
        "streetName": "Forretningsadresse",
        "streetNameDescription": "Eksempel: Tømmergata",
        "houseNumber": "Husnummer",
        "houseNumberDescription": "Eksempel: 16C",
        "postalCode": "Postnummer",
        "postalCodeDescription": "Eksempel: 0123",
        "city": "Sted",
        "cityDescription": "Eksempel: Oslo",
        "country": "Land"
      }
    },
    "step2": {
      "title": "Kontaktinformasjon",
      "description": "Registrer kontaktinformasjon til entreprenør",
      "phone": {
        "label": "Telefonnummer <i>(valgfritt)</i>",
        "labelSummary": "Telefonnummer",
        "description": "Eksempel: 91 23 45 67"
      },
      "email": {
        "label": "E-post <i>(valgfritt)</i>",
        "labelSummary": "E-post",
        "description": "Eksempel: kontakt@nordmann.no"
      },
      "office": {
        "label": "Kontor",
        "placeholder": "Velg kontor"
      }
    },
    "officeSection": {
      "title": "Ansvarlig kontor i {{tenantName}}",
      "description": "Velg hvilket kontor som skal være ansvarlig for entreprenøren"
    },
    "step3": {
      "title": "Oppsummering",
      "description": "Sjekk at informasjonen stemmer før du lagrer",
      "sections": {
        "companyInfo": "Entreprenør informasjon",
        "contactInfo": "Kontaktinformasjon",
        "officeInfo": "Kontor"
      },
      "edit": "Rediger",
      "submit": "Registrer entreprenør"
    },
    "navigation": {
      "next": "Neste",
      "cancel": "Avbryt",
      "backToSearch": "Tilbake til søk"
    },
    "cancelDialog": {
      "title": "Avbryt registrering",
      "description": "Er du sikker på at du vil avbryte? All utfylt informasjon vil gå tapt.",
      "cancel": "Fortsett registrering",
      "confirm": "Avbryt registrering"
    },
    "success": {
      "title": "Entreprenør opprettet",
      "description": "Entreprenøren ble opprettet."
    },
    "error": {
      "title": "Kunne ikke opprette entreprenør",
      "description": "Det oppstod en feil under opprettelse av entreprenør. Prøv igjen."
    }
  },
  "search": {
    "searchFieldLabel": "Søk etter entreprenør",
    "searchButton": "Søk",
    "registerButton": "Registrer entreprenør",
    "readyDescription": "Skriv inn søketerm for å søke etter entreprenører.",
    "loadingMessage": "Laster entreprenører...",
    "emptyMessage": "Ingen entreprenører funnet",
    "emptyDescription": "Prøv et annet søkeord.",
    "columns": {
      "name": "Navn",
      "contractorNumber": "Entreprenørnummer",
      "office": "Kontor"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv"
    },
    "forestCrewList": {
      "columns": {
        "name": "Navn leder",
        "deactivated": "Deaktivert",
        "phoneNumber": "Telefonnummer",
        "municipalities": "Kommuner",
        "createdBy": "Registrert",
        "modifiedBy": "Sist endret",
        "actions": "Handlinger"
      },
      "deactivatedBadge": "Deaktivert",
      "actions": {
        "edit": "Endre",
        "viewRemark": "Vis merknad",
        "setInactive": "Deaktiver skoglag",
        "setActive": "Gjenopprett skoglag",
        "delete": "Slett",
        "add": "Legg til skoglag"
      },
      "filters": {
        "ariaLabel": "Filtrer skoglag etter status",
        "allStatuses": "Vis alle skoglag",
        "active": "Kun aktive",
        "inactive": "Kun deaktiverte"
      },
      "statusDialog": {
        "deactivateConfirm": {
          "title": "Ønsker du å deaktivere {{name}}?",
          "description": "Skoglaget blir da ikke velgbart for nye oppdrag.",
          "action": "Deaktiver skoglaget",
          "cancel": "Avbryt"
        },
        "deactivateBlocked": {
          "title": "Kan ikke deaktivere {{name}}",
          "description": "Skoglaget er i et pågående oppdrag og kan ikke settes som deaktivert før oppdraget er fullført.",
          "ok": "OK"
        },
        "error": "Det oppstod en feil under oppdatering av status. Prøv igjen."
      },
      "remarkDialog": {
        "title": "Merknad",
        "close": "Lukk",
        "edit": "Endre merknad"
      },
      "deleteDialog": {
        "confirm": {
          "title": "Er du sikker på at du vil slette {{name}}?",
          "description": "All informasjon du har fylt ut vil gå tapt",
          "cancel": "Avbryt",
          "action": "Slett skoglaget"
        },
        "blocked": {
          "title": "Kan ikke slette {{name}}",
          "description": "Skoglaget er i et pågående oppdrag og kan ikke slettes før oppdraget er fullført.",
          "ok": "OK"
        },
        "errorTitle": "Kunne ikke slette skoglaget",
        "error": "Det oppstod en feil under sletting av skoglaget. Prøv igjen."
      },
      "emptyState": {
        "noData": {
          "title": "Det finnes ingen skoglag registrert på denne entreprenøren",
          "description": "Trykk på \"Legg til skoglag\" for å starte prosessen"
        }
      }
    }
  },
  "forestCrew": {
    "edit": {
      "title": "Endre skoglag",
      "backLink": "Tilbake til ressurser",
      "form": {
        "title": "Endre skoglag",
        "description": "Fyll inn feltene under for å endre et skoglag"
      },
      "fields": {
        "leaderName": {
          "label": "Navn på leder",
          "description": "Eksempel: Kari Nordmann"
        },
        "phoneNumber": {
          "label": "Telefonnummer",
          "description": "Eksempel: 91 23 45 67"
        },
        "municipalities": {
          "label": "Kommuner",
          "description": "Velg hvilke kommuner skoglaget har ansvar for"
        },
        "remark": {
          "label": "Merknad (valgfritt)"
        }
      },
      "actions": {
        "cancel": "Avbryt",
        "save": "Lagre skoglag"
      },
      "cancelDialog": {
        "title": "Vil du avbryte endring av skoglag?",
        "description": "Alle endringer du har gjort vil gå tapt og må fylles inn på nytt.",
        "confirmCancel": "Avbryt uten å lagre",
        "continueEditing": "Fortsett å endre"
      },
      "toast": {
        "error": {
          "title": "Kunne ikke lagre skoglaget",
          "description": "Det oppstod en feil ved lagring. Prøv igjen."
        }
      },
      "error": {
        "title": "Kunne ikke laste skoglag",
        "description": "Det oppstod en feil under lasting av skoglagsopplysninger. Prøv igjen.",
        "retry": "Prøv igjen",
        "goToResources": "Gå til ressurser"
      }
    }
  }
}
